let vars = {};

vars.html = document.querySelector('html');
vars.body = document.querySelector('body');
vars.header = document.querySelector('header');
vars.menu = document.querySelector('menu');
vars.home = document.querySelector('.home');
vars.popup = document.querySelector('.popup');
vars.isMobile = () => innerWidth <= 739;
vars.isTablet = () => innerWidth >= 740 && innerWidth <= 1024;
vars.isDesktop = () => innerWidth >= 1025;
vars.winWidth = window.innerWidth;

vars.getRandom = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

vars.regex = {
	text: /^([a-zA-Zа-яА-Я ]){1,100}$/,
	email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	phone: /^(\+7|7|8)?[-]?\(?[1-9][0-9]{2}\)?[-]?[0-9]{3}[-]?[0-9]{2}[-]?[0-9]{2}$/,
};

const loadFromJson = (path, callback) => {
	fetch(path)
		.then((response) => response.json())
		.then((data) => {
			callback(data);
		});
};

const checkIfOnPage = (path) => window.location.href.indexOf(path) > -1;
function loadAndUpdateUI(jsonFilePath, dataHandler) {
	loadFromJson(jsonFilePath, dataHandler);
}

function updateStatsUI(data) {
	let stats = data.service_statistics;
	document.querySelector('.users-number').innerHTML = stats.number_of_users.toLocaleString('ru-RU');
	document.querySelector('.brigadier-numbers').innerHTML = stats.number_of_brigades.toLocaleString('ru-RU');
	document.querySelector('.daily-traffic').innerHTML = `${stats.amount_of_daily_traffic_gb.toLocaleString('ru-RU')} <span>Гб</span>`;
}

function updateStatusesUI(data) {
	const statuses = data.service_operation_statuses;
	const elementsClasses = [
		{selector: '.protocols-wireguard',
			status: statuses.protocols.wireguard},
		{selector: '.protocols-ipsec',
			status: statuses.protocols.ipsec},
		{selector: '.protocols-openvpn',
			status: statuses.protocols.openvpn},
		{selector: '.embassies-telegram',
			status: statuses.embassies.telegram},
		{selector: '.embassies-whatsapp',
			status: statuses.embassies.whatsapp},
		{selector: '.embassies-tor',
			status: statuses.embassies.tor},
		{selector: '.headline-issuing',
			status: statuses.headline_infrastructure.issuing_configurations},
		{selector: '.headline-keyholder',
			status: statuses.headline_infrastructure.the_work_of_a_key_holder},
		{selector: '.headline-traffic',
			status: statuses.headline_infrastructure.traffic_movement},
	];

	elementsClasses.forEach((item) => {
		document.querySelector(item.selector).classList.add(`is-${item.status}`);
	});
}

if (checkIfOnPage('stats')) {
	loadAndUpdateUI('/data/statistics.json', updateStatsUI);
	loadAndUpdateUI('/data/statuses.json', updateStatusesUI);
}

export default vars;
